import React from "react";
import Slider from "react-slick";
import { formattedDateTime } from 'share/utils/Izenda.DateTimeUtils';
import { CHART_TYPE } from 'logic/data/Izenda.ChartDefaultConfig';

class HomePageSlider extends React.Component {
    sliders() {
        const { recentReportViewList,preview } = this.props;
        
         return recentReportViewList.map(report => {
            const reportPartContent = JSON.parse(report.reportPartContent);          
            let charttype = report.reportPartType == 'Chart' ? reportPartContent.properties.chartType : report.reportPartType;
            //Need to optimize in next release 3.9.2
            if (report.reportPartType == 'Gauge'){
              charttype = 'SolidGauge';
            } else if (reportPartContent.properties.chartType == CHART_TYPE.TreeMap){
              charttype = 'TreeMap';
            } else if (reportPartContent.properties.chartType == CHART_TYPE.HeatMap){
              charttype = 'HeatMap';
            }
              const createdDate = formattedDateTime(report.createdDate);
            return ( 
                <div 
                     className="recent-report-view"
                    onClick={ () => preview(report.reportID)}
                    key={report.reportID}
                 >
                     <div className={`img-report ${charttype}-Tile`}></div>
                    <div className='img-caption'>
                        <span className='report-name'> {report.reportName}</span>
                    {report.createdDate ? <span className='report-created-data'>Last View: {createdDate}</span> : '' }
                </div>
                 </div>
            );
        });
    }

  render() {
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
        {
            breakpoint: 1300,
            settings: {
              slidesToShow: 4.45,
            }
          },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            dots: true
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            dots: true
          }
        },
      ]
    };
  
    return (
      <Slider {...settings}>
            {this.sliders()}        
      </Slider>
    );
  }
}
export default HomePageSlider;


// WEBPACK FOOTER //
// ./ui/modules/Explore/NLQAsk/HomePageSlider.jsx